import flBusiness from '@framelink/flbusiness'
import environment from 'utils/enums/environment'

export const listFilter = (array, pattern, props) => flBusiness.Utils.filter(array, pattern, props)

export const compressImage = (string) => flBusiness.Utils.compressImage(string)

export const getFileUrl = (string) => flBusiness.Utils.getFileUrl(string)

export const valueFormatter = (value, id) => flBusiness.Format.byFieldId(value, id)

export const getTypeReference = (entityId, type) => flBusiness.Field.getTypeReferenced(entityId, type)

export const formulaFormatter = (entityId) => flBusiness.Formula.Expression.format(entityId)

export const formulaValidator = (entityId, formula) => flBusiness.Formula.Expression.valid(entityId, formula)

export const getNumberSubstitutions = (entityId) => flBusiness.Formula.getNumberSubstitutions(entityId)

export const getDateTimeSubstitutions = (entityId) => flBusiness.Formula.getDatetimeSubstitutions(entityId)

export const getTimeFormats = () => flBusiness.Utils.getTimeFormats()

export const getDateFormats = () => flBusiness.Utils.getDateFormats()

export const getFieldsExport = (entityId) => flBusiness.Excel.Export.getFields(entityId)

export function getDefaultValue(env, fieldId, docId) {
    return env === environment.Collection ?
        flBusiness.Collection.Documents.getDefaultValue(docId, fieldId) :
        flBusiness.Record.getDefaultValue(fieldId)
}

export const getOwners = (entityId) => flBusiness.PublicTable.getOwners(entityId)

export const getViewsByEntity = (entityId) => flBusiness.View.getAll(entityId)

export const getPublicTableSubstitutions = (entityId, ownerId) => flBusiness.PublicTable.getSubstitutions(entityId, ownerId)

export const  getPublicTableFields = (entityId, ownerId) => flBusiness.PublicTable.getFields(entityId, ownerId)

export const getEntityFields = (entityId) => flBusiness.Entity.getFields(entityId)

export const getPublicFormFields = (entityId) => flBusiness.PublicForm.getFields(entityId)

export const getPublicLink = (formId) => flBusiness.PublicForm.getPublicLink(formId)

export const getSmsEmissions = (entityId) => flBusiness.Sms.getEmissions(entityId)

export const getSmsTemplates = (entityId) => flBusiness.Sms.Template.getAll(entityId)

export const getSmsSubstitutions = (entityId) => flBusiness.Sms.getSubstitutions(entityId)

export const getEmailEmissions = (entityId) => flBusiness.Email.getEmissions(entityId)

export const getEmailTemplates = (entityId) => flBusiness.Email.Template.getAll(entityId)

export const getEmailSubstitutions = (entityId) => flBusiness.Email.getSubstitutions(entityId)

export const getSenders = () => flBusiness.Application.Sender.getAll()

export const getTimeout = () => flBusiness.Application.Sender.getTimeout()

export const getFormEmailOptions = (entityId) => flBusiness.PublicForm.getEmailOptions(entityId)

export const getTableEmailOptions = (emission) => flBusiness.PublicTable.getByOwner(emission)

export const getFieldsByType = (entityId, type) => flBusiness.Entity.getFieldsByType(entityId, type)

export const getAppName = () => flBusiness.Application.getName()

export const getDataExportTemplates = (entityId) => flBusiness.DataExport.Template.getAll(entityId)

export const getDataExportOptions = (sourceEntityId, destinationEntityId) => flBusiness.DataExport.getFieldsOptions(sourceEntityId, destinationEntityId)

export const getTestEmail = () => flBusiness.Email.getTestAddress()

export const getTestPhone = () => flBusiness.Sms.getTestAddress()

export const getEntityRelatedFields = (entityId) => flBusiness.Entity.getRelatedFields(entityId)

export const getIcons = (pattern) => flBusiness.Utils.getIcons(pattern)

export const getRelatedFieldsForField = (field) => flBusiness.Field.getRelatedFields(field)

export const getDefaultOptions = (field) => flBusiness.Field.getDefaultValueOptions(field)

export const getFieldDefaultValue = (field) => flBusiness.Field.getDefaultValue(field)

export const getLookupOptions = (fieldId) => flBusiness.Field.getLookupOptions(fieldId)

export const getFilterFields = (entity, fields) => flBusiness.Rollup.getFilterFields(entity, fields)

export const getLabelFields = (entity) => flBusiness.Rollup.getLabelFields(entity)

export const getPdfTemplates = (entity) => flBusiness.PdfTemplate.getAll(entity)

export const getFieldsPdf = (file) => flBusiness.PdfTemplate.getPDFFields(file)

export const getEntityFieldsPdf = (entity) => flBusiness.PdfTemplate.getEntityFields(entity)

export const openTemplate = (id) => flBusiness.PdfTemplate.showTemplate(id)

export const getDateSubstitutions = (entityId) => flBusiness.Email.getDateSubstitutions(entityId)

export const getDurationSubstitutions = (entityId) => flBusiness.Email.getNumberSubstitutions(entityId)

export const getView = (id) => flBusiness.View.get(id)

export const getPublicForms = (entityId) => flBusiness.PublicForm.getAll(entityId)

export const adminInit = () => flBusiness.adminInit()

export const initApi = () => flBusiness.Version.api()

export const getVersion = () => flBusiness.Version.get()

export const getLanguage = () => flBusiness.Language.get()

export const setLanguage = (lang) => flBusiness.Language.set(lang)

export const getLanguages = () => flBusiness.Language.getAll()

export const getSimilarValues = (id, record, string, env) => env === environment.Collection ?
	flBusiness.Collection.getSimilarValues(id, record, string) : flBusiness.Record.getSimilarValues(id, string)

export const getEntitiesIcons = (pattern) => flBusiness.Entity.getAllWithIcons(pattern)

export function isLinkedActive(id, row, env) {
	return env === environment.Collection ?
		flBusiness.Collection.isLinkedActive(id, row) :
		flBusiness.Record.isLinkedActive(id)
}

export const filterCards = (pattern, modules) => flBusiness.Module.search(pattern, modules)

export const getAccess = (entityId) => flBusiness.Entity.hasAccess(entityId)

export const getFilteringCandidtes = (entityId) => flBusiness.Entity.getFilteringCandidtes(entityId)

export const getValueByPath = (doc, pathId) => flBusiness.Documents.getValueByPathSync(doc, pathId)

export const getLinkedOptions = (id, row, env) => {
	switch (env) {
		case environment.Collection:
			return flBusiness.Collection.getLinkedOptions(id, row)

		case environment.Record:
			return flBusiness.Record.getLinkedOptions(id)

		default:
			return flBusiness.Field.Linked.getOptions(id)
	}
}

export const debounce = (func, delay) => {
	let debounceTimer
	return function () {
		const context = this
		const args = arguments
		clearTimeout(debounceTimer)
		debounceTimer = setTimeout(() => func.apply(context, args), delay)
	}
}

export function isMobile() {
    return /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
}

export const getCountry = () => navigator.language.split('-').pop().toLowerCase()

export const convertColor = (color) => {
    const hex = color.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (m, r, g, b) => '#' + r + r + g + g + b + b).substring(1).match(/.{2}/g)
    const rgb = hex.map(x => parseInt(x, 16))
    return rgb.join()
}